const E = {
    newjob: 'New Job',
    neworder: 'New Order',
    NoResults: 'We couldn’t find any prepaid request that match your search criteria.',
    NoResultsBody: 'Please double check your search criteria or try a broader search. If you need assistance, please contact your Bureau Veritas representative.',
    Draft: 'Draft',
    Pending: 'Pending',
    Paid: 'Paid',
    Cancelled: 'Cancelled',
    'All Requests': 'All Requests',

  };
  
  const F = {
    newjob: 'Nouveau travail',
    neworder: 'Nouvel ordre',
    NoResults: 'Nous n’avons trouvé aucune demande Prépayé correspondant à vos critères de recherche.',
    NoResultsBody: 'Veuillez vérifier vos critères de recherche ou essayer une recherche plus large. Si vous avez besoin d’aide, veuillez contacter votre représentant Bureau Veritas.',
    Draft: 'Brouillon',
    Pending: 'En attente',
    Paid: 'Payé',
    Cancelled: 'Annulé',
    'All Requests': 'Toutes les demandes',
  };
  
  export default { E, F };
  


// WEBPACK FOOTER //
// ./src/constants/translations/prepaidRequest.js